import { c as _c } from "react/compiler-runtime";
import { Menu as MenuPrimitive } from '@base-ui/react/menu';
import { CheckIcon, ChevronRightIcon, DotFilledIcon as CircleIcon } from '@radix-ui/react-icons';
import * as React from 'react';
import { cn } from '@/lib/utils';
type PositionerProps = Pick<React.ComponentProps<typeof MenuPrimitive.Positioner>, 'align' | 'alignOffset' | 'anchor' | 'collisionBoundary' | 'collisionPadding' | 'side' | 'sideOffset' | 'sticky'>;
type PortalProps = Pick<React.ComponentProps<typeof MenuPrimitive.Portal>, 'container' | 'keepMounted'>;
type SelectCompatProps = {
  onSelect?: React.MouseEventHandler<HTMLElement>;
};
function DropdownMenu(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <MenuPrimitive.Root data-slot="dropdown-menu" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuPortal(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <MenuPrimitive.Portal data-slot="dropdown-menu-portal" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <MenuPrimitive.Trigger data-slot="dropdown-menu-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuContent(t0) {
  const $ = _c(32);
  let align;
  let alignOffset;
  let anchor;
  let className;
  let collisionBoundary;
  let collisionPadding;
  let container;
  let keepMounted;
  let props;
  let side;
  let sticky;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      sideOffset: t1,
      align,
      alignOffset,
      anchor,
      collisionBoundary,
      collisionPadding,
      container,
      keepMounted,
      side,
      sticky,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = align;
    $[2] = alignOffset;
    $[3] = anchor;
    $[4] = className;
    $[5] = collisionBoundary;
    $[6] = collisionPadding;
    $[7] = container;
    $[8] = keepMounted;
    $[9] = props;
    $[10] = side;
    $[11] = sticky;
    $[12] = t1;
  } else {
    align = $[1];
    alignOffset = $[2];
    anchor = $[3];
    className = $[4];
    collisionBoundary = $[5];
    collisionPadding = $[6];
    container = $[7];
    keepMounted = $[8];
    props = $[9];
    side = $[10];
    sticky = $[11];
    t1 = $[12];
  }
  const sideOffset = t1 === undefined ? 4 : t1;
  let t2;
  if ($[13] !== className) {
    t2 = cn("z-50 max-h-(--available-height) min-w-32 origin-(--transform-origin) overflow-x-hidden overflow-y-auto rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", "[--sq-r:1rem] sq:relative sq:rounded-(--sq-r) sq:shadow-none sq:drop-shadow-md", className);
    $[13] = className;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== props || $[16] !== t2) {
    t3 = <MenuPrimitive.Popup data-slot="dropdown-menu-content" className={t2} {...props} />;
    $[15] = props;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== align || $[19] !== alignOffset || $[20] !== anchor || $[21] !== collisionBoundary || $[22] !== collisionPadding || $[23] !== side || $[24] !== sideOffset || $[25] !== sticky || $[26] !== t3) {
    t4 = <MenuPrimitive.Positioner align={align} alignOffset={alignOffset} anchor={anchor} collisionBoundary={collisionBoundary} collisionPadding={collisionPadding} side={side} sideOffset={sideOffset} sticky={sticky}>{t3}</MenuPrimitive.Positioner>;
    $[18] = align;
    $[19] = alignOffset;
    $[20] = anchor;
    $[21] = collisionBoundary;
    $[22] = collisionPadding;
    $[23] = side;
    $[24] = sideOffset;
    $[25] = sticky;
    $[26] = t3;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  let t5;
  if ($[28] !== container || $[29] !== keepMounted || $[30] !== t4) {
    t5 = <MenuPrimitive.Portal keepMounted={keepMounted} container={container}>{t4}</MenuPrimitive.Portal>;
    $[28] = container;
    $[29] = keepMounted;
    $[30] = t4;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  return t5;
}
function DropdownMenuGroup(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <MenuPrimitive.Group data-slot="dropdown-menu-group" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuItem(t0) {
  const $ = _c(20);
  let className;
  let closeOnClick;
  let inset;
  let onClick;
  let onSelect;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      variant: t1,
      onSelect,
      onClick,
      closeOnClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = closeOnClick;
    $[3] = inset;
    $[4] = onClick;
    $[5] = onSelect;
    $[6] = props;
    $[7] = t1;
  } else {
    className = $[1];
    closeOnClick = $[2];
    inset = $[3];
    onClick = $[4];
    onSelect = $[5];
    props = $[6];
    t1 = $[7];
  }
  const variant = t1 === undefined ? "default" : t1;
  const t2 = closeOnClick ?? (onSelect ? false : undefined);
  let t3;
  if ($[8] !== className) {
    t3 = cn("relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 data-highlighted:bg-accent data-highlighted:text-accent-foreground data-inset:pl-8 data-[variant=destructive]:text-destructive data-[variant=destructive]:data-highlighted:bg-destructive/10 data-[variant=destructive]:data-highlighted:text-destructive dark:data-[variant=destructive]:data-highlighted:bg-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground data-[variant=destructive]:*:[svg]:text-destructive!", "[--sq-r:.6rem] sq:rounded-(--sq-r)", className);
    $[8] = className;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== onClick || $[11] !== onSelect) {
    t4 = event => {
      onSelect?.(event);
      onClick?.(event);
    };
    $[10] = onClick;
    $[11] = onSelect;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== inset || $[14] !== props || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== variant) {
    t5 = <MenuPrimitive.Item data-slot="dropdown-menu-item" data-inset={inset} data-variant={variant} closeOnClick={t2} className={t3} onClick={t4} {...props} />;
    $[13] = inset;
    $[14] = props;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = variant;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}
function DropdownMenuCheckboxItem(t0) {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 data-highlighted:bg-accent data-highlighted:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="pointer-events-none absolute left-2 flex size-3.5 items-center justify-center"><MenuPrimitive.CheckboxItemIndicator><CheckIcon className="size-4" /></MenuPrimitive.CheckboxItemIndicator></span>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== t1) {
    t3 = <MenuPrimitive.CheckboxItem data-slot="dropdown-menu-checkbox-item" className={t1} {...props}>{t2}{children}</MenuPrimitive.CheckboxItem>;
    $[7] = children;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function DropdownMenuRadioGroup(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <MenuPrimitive.RadioGroup data-slot="dropdown-menu-radio-group" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuRadioItem(t0) {
  const $ = _c(17);
  let children;
  let className;
  let onClick;
  let onSelect;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      onSelect,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = onClick;
    $[4] = onSelect;
    $[5] = props;
  } else {
    children = $[1];
    className = $[2];
    onClick = $[3];
    onSelect = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 data-highlighted:bg-accent data-highlighted:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== onClick || $[9] !== onSelect) {
    t2 = event => {
      onSelect?.(event);
      onClick?.(event);
    };
    $[8] = onClick;
    $[9] = onSelect;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="pointer-events-none absolute left-2 flex size-3.5 items-center justify-center"><MenuPrimitive.RadioItemIndicator><CircleIcon className="size-2 fill-current" /></MenuPrimitive.RadioItemIndicator></span>;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== children || $[13] !== props || $[14] !== t1 || $[15] !== t2) {
    t4 = <MenuPrimitive.RadioItem data-slot="dropdown-menu-radio-item" className={t1} onClick={t2} {...props}>{t3}{children}</MenuPrimitive.RadioItem>;
    $[12] = children;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
function DropdownMenuLabel(t0) {
  const $ = _c(10);
  let className;
  let inset;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = inset;
    $[3] = props;
  } else {
    className = $[1];
    inset = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("px-2 py-1.5 text-sm font-medium data-inset:pl-8", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== inset || $[7] !== props || $[8] !== t1) {
    t2 = <div data-slot="dropdown-menu-label" data-inset={inset} className={t1} {...props} />;
    $[6] = inset;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function DropdownMenuSeparator(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("-mx-1 my-1 h-px bg-border", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <MenuPrimitive.Separator data-slot="dropdown-menu-separator" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DropdownMenuShortcut(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("ml-auto text-xs tracking-[.1em] text-muted-foreground", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <span data-slot="dropdown-menu-shortcut" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DropdownMenuSub(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <MenuPrimitive.SubmenuRoot data-slot="dropdown-menu-sub" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuSubTrigger(t0) {
  const $ = _c(13);
  let children;
  let className;
  let inset;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = inset;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    inset = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-highlighted:bg-accent data-highlighted:text-accent-foreground data-inset:pl-8 data-popup-open:bg-accent data-popup-open:text-accent-foreground", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronRightIcon className="ml-auto size-4" />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== inset || $[10] !== props || $[11] !== t1) {
    t3 = <MenuPrimitive.SubmenuTrigger data-slot="dropdown-menu-sub-trigger" data-inset={inset} className={t1} {...props}>{children}{t2}</MenuPrimitive.SubmenuTrigger>;
    $[8] = children;
    $[9] = inset;
    $[10] = props;
    $[11] = t1;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
function DropdownMenuSubContent(t0) {
  const $ = _c(20);
  let alignOffset;
  let className;
  let collisionBoundary;
  let collisionPadding;
  let props;
  let sideOffset;
  let sticky;
  if ($[0] !== t0) {
    ({
      className,
      alignOffset,
      collisionBoundary,
      collisionPadding,
      sideOffset,
      sticky,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alignOffset;
    $[2] = className;
    $[3] = collisionBoundary;
    $[4] = collisionPadding;
    $[5] = props;
    $[6] = sideOffset;
    $[7] = sticky;
  } else {
    alignOffset = $[1];
    className = $[2];
    collisionBoundary = $[3];
    collisionPadding = $[4];
    props = $[5];
    sideOffset = $[6];
    sticky = $[7];
  }
  let t1;
  if ($[8] !== className) {
    t1 = cn("z-50 min-w-32 origin-(--transform-origin) overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className);
    $[8] = className;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== props || $[11] !== t1) {
    t2 = <MenuPrimitive.Popup data-slot="dropdown-menu-sub-content" className={t1} {...props} />;
    $[10] = props;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== alignOffset || $[14] !== collisionBoundary || $[15] !== collisionPadding || $[16] !== sideOffset || $[17] !== sticky || $[18] !== t2) {
    t3 = <MenuPrimitive.Portal><MenuPrimitive.Positioner alignOffset={alignOffset} collisionBoundary={collisionBoundary} collisionPadding={collisionPadding} sideOffset={sideOffset} sticky={sticky}>{t2}</MenuPrimitive.Positioner></MenuPrimitive.Portal>;
    $[13] = alignOffset;
    $[14] = collisionBoundary;
    $[15] = collisionPadding;
    $[16] = sideOffset;
    $[17] = sticky;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
}
export { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger };